module.exports = __webpack_public_path__ + "../resources/images/agreed-upon-time-plate-4e1150d71adda14f91d5d1d49ba8d53d.png";